import { http, HttpResponse } from 'msw';
import { PlessService } from '../../app/shared/pless-service.model';
import { ResponseUtils } from './response-utils';

let count = 0;

export const kymw48Handlers = [
  // バイヤークロス商品設定一覧取得 /kymw48/getBuyerCrossGoodsSetList
  http.post(PlessService.SERVICE.getBuyerCrossGoodsSetList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getBuyerCrossGoodsSetList.url, req);
    return HttpResponse.json(getBuyerCrossGoodsSetListResponse4);
    // return HttpResponse.json(getBuyerCrossGoodsSetListResponseEmpty);
    // count = count + 1;
    // if (count === 1) {
    //   return HttpResponse.json(getBuyerCrossGoodsSetListResponseEmpty);
    // } else if (count === 2) {
    //   return HttpResponse.json(getBuyerCrossGoodsSetListResponse4);
    // } else if (count === 3) {
    //   return HttpResponse.json(getBuyerCrossGoodsSetListResponseEmpty);
    // } else {
    //   return HttpResponse.json(getBuyerCrossGoodsSetListResponse4);
    // }
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // バイヤークロス商品設定マスタ一覧更新 /kymw48/updateBuyerCrossGoodsSetMasterList
  http.post(PlessService.SERVICE.updateBuyerCrossGoodsSetMasterList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateBuyerCrossGoodsSetMasterList.url, req);
    return HttpResponse.json(updateBuyerCrossGoodsSetMasterListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.getE0540();
    // return ResponseUtils.get500();
  }),

  // クロスコード取得 /kymw48/getCrossCode
  http.post(PlessService.SERVICE.getCrossCode.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getCrossCode.url, req);
    return HttpResponse.json(getCrossCodeResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // クロス商品情報一覧取得 /kymw48/getCrossGoodsInfoList
  http.post(PlessService.SERVICE.getCrossGoodsInfoList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getCrossGoodsInfoList.url, req);
    return HttpResponse.json(getCrossGoodsInfoListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // Pコード商品情報取得 /kymw48/getPcodeGoodsInfo
  http.post(PlessService.SERVICE.getPcodeGoodsInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getPcodeGoodsInfo.url, req);
    return HttpResponse.json(getPcodeGoodsInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // クロス設定削除 /kymw48/deleteCrossSet
  http.post(PlessService.SERVICE.deleteCrossSet.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.deleteCrossSet.url, req);
    return HttpResponse.json(deleteCrossSetResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // クロス設定登録 /kymw48/registCrossSet
  http.post(PlessService.SERVICE.registCrossSet.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.registCrossSet.url, req);
    return HttpResponse.json(registCrossSetResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // クロス設定更新 /kymw48/updateCrossSet
  http.post(PlessService.SERVICE.updateCrossSet.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateCrossSet.url, req);
    return HttpResponse.json(updateCrossSetResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品未選定チェック /kymw48/checkUnselectedGoods
  http.post(PlessService.SERVICE.checkUnselectedGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.checkUnselectedGoods.url, req);
    checkUnselectedGoodsResponse.result.obj.CheckResult = '0' // 0:選定済 / 1:未選定（エラーになる）
    return HttpResponse.json(checkUnselectedGoodsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 過去クロス商品設定一覧取得 /kymw48/getPastCrossGoodsSetList
  http.post(PlessService.SERVICE.getPastCrossGoodsSetList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getPastCrossGoodsSetList.url, req);
    return HttpResponse.json(getPastCrossGoodsSetListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 対象クロス商品情報更新 /kymw48/updateTargetCrossGoodsInfo
  http.post(PlessService.SERVICE.updateTargetCrossGoodsInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateTargetCrossGoodsInfo.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 媒体一覧取得 /kymw48/getMediumList
  http.post(PlessService.SERVICE.KYMW48getMediumList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW48getMediumList.url, req);
    return HttpResponse.json(getMediumListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

export const getBuyerCrossGoodsSetListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        DelivCatalogId: '20240101',
        CrossCode: '00000001',
        MediumType: '001',
        AutoDefaultSettings: 0,
        CrossGoodsSetList: [
          {
            PublishSeq: 1,
            PCode: 'P0000011',
            GuideGoodsName: '商品名1-1',
            GuideStandardName: '規格名',
            ChildKomaSettings: 0,
          },
          {
            PublishSeq: 2,
            PCode: 'P0000012',
            GuideGoodsName: '商品名1-2',
            GuideStandardName: '規格名1-2',
            ChildKomaSettings: 1,
          },
          {
            PublishSeq: 3,
            PCode: 'P0000013',
            GuideGoodsName: '商品名1-3',
            GuideStandardName: '規格名1-3',
            ChildKomaSettings: 1,
          },
        ]
      },
      {
        DelivCatalogId: '20231201',
        CrossCode: '00000002',
        MediumType: '001',
        AutoDefaultSettings: 1,
        CrossGoodsSetList: [
          {
            PublishSeq: 1,
            PCode: 'P0000021',
            GuideGoodsName: '商品名2-1',
            GuideStandardName: '規格名2-1',
            ChildKomaSettings: 1,
          },
          {
            PublishSeq: 2,
            PCode: 'P0000022',
            GuideGoodsName: '商品名2-2',
            GuideStandardName: '規格名2-2',
            ChildKomaSettings: 0,
          },
          {
            PublishSeq: 3,
            PCode: 'P0000023',
            GuideGoodsName: '商品名2-3',
            GuideStandardName: '規格名2-3',
            ChildKomaSettings: 0,
          },
          {
            PublishSeq: 4,
            PCode: 'P0000024',
            GuideGoodsName: '商品名2-4',
            GuideStandardName: '規格名2-4',
            ChildKomaSettings: 0,
          },
          {
            PublishSeq: 5,
            PCode: 'P0000025',
            GuideGoodsName: '商品名2-5',
            GuideStandardName: '規格名2-5',
            ChildKomaSettings: 1,
          },
        ]
      },
      {
        DelivCatalogId: '20231101',
        CrossCode: '00000003',
        MediumType: '001',
        AutoDefaultSettings: 0,
        CrossGoodsSetList: [
          {
            PublishSeq: 1,
            PCode: 'P0000031',
            GuideGoodsName: '商品名3-1',
            GuideStandardName: '規格名3-1',
            ChildKomaSettings: 1,
          },
        ]
      },
      {
        DelivCatalogId: '20231001',
        CrossCode: '00000004',
        MediumType: '001',
        AutoDefaultSettings: 1,
        CrossGoodsSetList: [
          {
            PublishSeq: 1,
            PCode: 'P0000041',
            GuideGoodsName: '商品名4-1',
            GuideStandardName: '規格名4-1',
            ChildKomaSettings: 1,
          },
          {
            PublishSeq: 2,
            PCode: 'P0000042',
            GuideGoodsName: '商品名4-2',
            GuideStandardName: '規格名4-2',
            ChildKomaSettings: 0,
          },
          {
            PublishSeq: 3,
            PCode: 'P0000043',
            GuideGoodsName: '商品名4-3',
            GuideStandardName: '規格名4-3',
            ChildKomaSettings: 0,
          },
        ]
      },
    ],
  },
};

export const getBuyerCrossGoodsSetListResponse2 = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        DelivCatalogId: '20240101',
        CrossCode: '00000001',
        MediumType: '001',
        AutoDefaultSettings: 0,
        CrossGoodsSetList: [
          {
            PublishSeq: 1,
            PCode: 'P0000011',
            GuideGoodsName: '商品名1-1',
            GuideStandardName: '規格名',
            ChildKomaSettings: 0,
          },
        ]
      },
    ],
  },
};

export const getBuyerCrossGoodsSetListResponse3 = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        DelivCatalogId: '20240101',
        CrossCode: '00000001',
        MediumType: '001',
        AutoDefaultSettings: 0,
        CrossGoodsSetList: [
          {
            PublishSeq: 1,
            PCode: 'P0000011',
            GuideGoodsName: '商品名1-1',
            GuideStandardName: '規格名',
            ChildKomaSettings: 0,
          },
          {
            PublishSeq: 2,
            PCode: 'P0000012',
            GuideGoodsName: '商品名1-2',
            GuideStandardName: '規格名1-2',
            ChildKomaSettings: 1,
          },
          {
            PublishSeq: 3,
            PCode: 'P0000013',
            GuideGoodsName: '商品名1-3',
            GuideStandardName: '規格名1-3',
            ChildKomaSettings: 1,
          },
        ]
      },
    ],
  },
};

export const getBuyerCrossGoodsSetListResponse4 = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "DelivCatalogId": "20251102",
        "CrossCode": "00000035",
        "MediumType": "003",
        "AutoDefaultSettings": 0,
        "CrossGoodsSetList": [
          {
            "PublishSeq": 1,
            "PCode": "P0536350",
            "GuideGoodsName": "甲州干小梅",
            "GuideStandardName": "１４０ｇ",
            "ChildKomaSettings": 0
          },
          {
            "PublishSeq": 2,
            "PCode": "P0615595",
            "GuideGoodsName": "ひじきふりかけ",
            "GuideStandardName": "１０５ｇ",
            "ChildKomaSettings": 0
          }
        ]
      },
      {
        "DelivCatalogId": "20251102",
        "CrossCode": "00000038",
        "MediumType": "003",
        "AutoDefaultSettings": 0,
        "CrossGoodsSetList": [
          {
            "PublishSeq": 2,
            "PCode": "P2676160",
            "GuideGoodsName": "横浜ロイヤルパークホテル監修　クラムチャウダー",
            "GuideStandardName": "１人前１５０ｇ",
            "ChildKomaSettings": 1
          },
          {
            "PublishSeq": 1,
            "PCode": "P2676161",
            "GuideGoodsName": "野菜が美味しいボルシチ",
            "GuideStandardName": "１人前２４０ｇ",
            "ChildKomaSettings": 0
          },
          {
            "PublishSeq": 3,
            "PCode": "P2676162",
            "GuideGoodsName": "金沢料亭「金茶寮」海老ちらし寿司の素",
            "GuideStandardName": "１合用７５ｇ",
            "ChildKomaSettings": 0
          },
          {
            "PublishSeq": 4,
            "PCode": "P2676163",
            "GuideGoodsName": "千房　国産牛すじこんにゃく",
            "GuideStandardName": "１人前１１５ｇ",
            "ChildKomaSettings": 1
          }
        ]
      }
    ]
  }
};

export const getBuyerCrossGoodsSetListResponseEmpty = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [],
  },
};

const updateBuyerCrossGoodsSetMasterListResponse = {
  status: 'ok',
  message: '処理完了',
};

const getCrossCodeResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CrossCode: '00000001',
    }
    // obj: null
  }
};
const getCrossGoodsInfoListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        PublishSeq: 1,
        PCode: 'P1111111',
        GuideGoodsName: '商品名1',
        GuideStandardName: '規格名1',
        ChildKomaSettings: 1,
      },
      {
        PublishSeq: 2,
        PCode: 'P2222222',
        GuideGoodsName: '商品名2',
        GuideStandardName: '規格名2',
        ChildKomaSettings: 0,
      },
      {
        PublishSeq: 3,
        PCode: 'P3333333',
        GuideGoodsName: '商品名3',
        GuideStandardName: '規格名3',
        ChildKomaSettings: 1,
      },
      {
        PublishSeq: 4,
        PCode: 'P4444444',
        GuideGoodsName: '商品名4',
        GuideStandardName: '規格名4',
        ChildKomaSettings: 1,
      },
      {
        PublishSeq: 5,
        PCode: 'P5555555',
        GuideGoodsName: '商品名5',
        GuideStandardName: '規格名5',
        ChildKomaSettings: 0,
      },
      {
        PublishSeq: 6,
        PCode: 'P6666666',
        GuideGoodsName: '商品名6',
        GuideStandardName: '規格名6',
        ChildKomaSettings: 1,
      },
      {
        PublishSeq: 7,
        PCode: 'P7777777',
        GuideGoodsName: '商品名7',
        GuideStandardName: '規格名7',
        ChildKomaSettings: 0,
      },
      {
        PublishSeq: 8,
        PCode: 'P8888888',
        GuideGoodsName: '商品名8',
        GuideStandardName: '規格名8',
        ChildKomaSettings: 0,
      },
    ]
  }
};
const getPcodeGoodsInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      PCode: 'P9999999',
      GuideGoodsName: '商品名9',
      GuideStandardName: '規格名9',
    },
  }
};
const deleteCrossSetResponse = {
  status: 'ok',
  message: '処理完了',
};
const registCrossSetResponse = {
  status: 'ok',
  message: '処理完了',
};
const updateCrossSetResponse = {
  status: 'ok',
  message: '処理完了',
};
const checkUnselectedGoodsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CheckResult: '0',
    }
  }
};
const getPastCrossGoodsSetListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        DelivCatalogId: '20231002',
        OrderCode: '2023300',
        CrossCode: '00000001',
        MediumType: '001',
        MediumName: 'ハピデリ',
        CrossGoodsSetList: [
          {
            PublishSeq: 1,
            PCode: 'P2230364',
            GuideGoodsName: '極小粒納豆カップ４',
            GuideStandardName: '３０ｇ×４たれ・からし付',
            ChildKomaSettings: 1,
          },
          {
            PublishSeq: 2,
            PCode: 'P2230372',
            GuideGoodsName: 'タマゴプリン',
            GuideStandardName: '（１００ｇ×３）×２',
            ChildKomaSettings: 1,
          },
          {
            PublishSeq: 3,
            PCode: 'P2230380',
            GuideGoodsName: 'スカッシーソフトフィット',
            GuideStandardName: 'ＳＳサイズ',
            ChildKomaSettings: 1,
          },
        ]
      },
      {
        DelivCatalogId: '20231003',
        OrderCode: '2023310',
        CrossCode: '00000002',
        MediumType: '003',
        MediumName: 'ぐるめぐり',
        CrossGoodsSetList: [
          {
            PublishSeq: 1,
            PCode: 'P2230380',
            GuideGoodsName: 'スカッシーソフトフィット',
            GuideStandardName: 'ＳＳサイズ',
            ChildKomaSettings: 0,
          },
          {
            PublishSeq: 2,
            PCode: 'P2230364',
            GuideGoodsName: '極小粒納豆カップ４',
            GuideStandardName: '３０ｇ×４たれ・からし付',
            ChildKomaSettings: 0,
          },
        ]
      }
    ]
  }
}

const getMediumListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        MediumType: "001",
        MediumName: "ハピデリ",
      },
      {
        MediumType: "003",
        MediumName: "ぐるめぐり",
      },
    ]
  }
}
